import { Container, Typography } from '@mui/material';
import React from 'react';
import PermissionsTable from './permissionsTable';
import Device from '../../models/device';
import UserFetch from '../../userFetch';

const PermissionsPage = function () {
  const [devices, setDevices] = React.useState<Device[]>([]);

  const fetchDevices = () => {
    UserFetch('/api/devices?type=short')
      .then((response) => response.json())
      .then((d: Device[]) => {
        setDevices(d)
      });
  }

  React.useEffect(() => {
    fetchDevices();
  }, []);

  return (
    <Container maxWidth={false} sx={{ py: 0 }}>
      <PermissionsTable devices={devices} />
    </Container>
  );
}

export default React.memo(PermissionsPage);